import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useClientSettings } from 'hooks/clientSettings'
import { globalNotificationActions } from 'state/globalNotification'

export const useGlobalNotification = () => {
  const dispatch = useDispatch()
// @ts-expect-error - TS18046 - 'state' is of type 'unknown'.
  const isLoggedIn = useSelector((state) => Boolean(state.auth?.user))
// @ts-expect-error - TS18046 - 'state' is of type 'unknown'.
  const notificationData = useSelector((state) => state.globalNotification?.data) || {}

  const {
    value: globalNotificationSettings = {},
    updateSettings,
    queueSettingsUpdate
  } = useClientSettings('globalNotification')

  const updateAck = useCallback(
    (
      value: {
        id: string;
        acknowledgedAt: Date;
      },
    ) => {
      if (isLoggedIn) {
      updateSettings(value)
    } else {
      queueSettingsUpdate(value)
    }
    },
    [isLoggedIn, updateSettings, queueSettingsUpdate]
  )

  const fetchGlobalNotification = useCallback(() => {
    dispatch(globalNotificationActions.fetchGlobalNotification())
  }, [globalNotificationActions.fetchGlobalNotification])


  return {
    seenAt: globalNotificationSettings?.acknowledgedAt,
    updateAck,
    fetchGlobalNotification,
    notificationData
  }
}

export default useGlobalNotification
